import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";
import GrDrawer from "./GrDrawer";
import GrButton from "./GrButton";

// Filter drawer: one look for every filter in the portal (Coins History, Videos Library,
// Weight Tracker, chart filters). GrDrawer frame (title bar with ×, right side, full width
// on phones); the fields stack in the body; the footer always sits at the bottom with two
// equal-width buttons: clear (secondary, left) and apply (primary, right).
export default function GrFilterDrawer({
  open,
  onClose,
  title,
  children,
  onApply,
  applyLabel,
  onClear,
  clearLabel,
  applyDisabled = false,
  loading = false,
}) {
  return (
    <GrDrawer
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <GrButton
            variant="secondary"
            onClick={onClear}
            disabled={loading}
            sx={{ flex: 1 }}
          >
            {clearLabel}
          </GrButton>
          <GrButton
            onClick={onApply}
            disabled={applyDisabled}
            loading={loading}
            sx={{ flex: 1 }}
          >
            {applyLabel}
          </GrButton>
        </>
      }
    >
      <Box sx={{ display: "grid", gap: gr.space[4] }}>{children}</Box>
    </GrDrawer>
  );
}

GrFilterDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  // The filter fields; stacked full width.
  children: PropTypes.node,
  onApply: PropTypes.func.isRequired,
  applyLabel: PropTypes.node.isRequired,
  onClear: PropTypes.func.isRequired,
  clearLabel: PropTypes.node.isRequired,
  applyDisabled: PropTypes.bool,
  // Apply shows a spinner; both buttons wait.
  loading: PropTypes.bool,
};
